export default class DynamicVideoWithTextOverlay {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    $('[data-play-video]', this.$el).on('click', () => this.playVideo());
  }

  playVideo() {
    const $overlay = this.$el.find('[data-video-overlay]');
    const $video = this.$el.find('iframe');

    if (!$video.length) { return; }

    // Get src of video, and replace with auto-play url
    const videoSrc = $video.attr('src');
    const delimiter = (videoSrc != null ? videoSrc.indexOf('?') : undefined) === -1 ? '?' : '&';
    const videoSrcNew = `${videoSrc}${delimiter}autoplay=1`;
    $video.attr('src', videoSrcNew);

    setTimeout(() => {
      $overlay.addClass('overlay-inactive');
    },
    100);
  }

  onSectionUnload() {
    this.remove();
  }

  remove() {
    $('[data-play-video]', this.$el).off('click');
    if (this.video) {
      this.video.remove();
    }
  }
}
